import { useEffect, useState } from "react";
import { Network } from "@capacitor/network";

// Contrairement au bouton retour (useAndroidBackButton.js), @capacitor/network
// a un vrai repli web (navigator.onLine + evenements online/offline) : pas
// besoin de garde Capacitor.isNativePlatform() ici, le meme code tourne sur
// le site et sur l'app.
export function useNetworkStatus() {
  const [online, setOnline] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let listener;

    Network.getStatus().then(status => {
      if (!cancelled) setOnline(status.connected);
    });

    Network.addListener("networkStatusChange", status => {
      setOnline(status.connected);
    }).then(h => {
      if (cancelled) h.remove();
      else listener = h;
    });

    return () => { cancelled = true; listener?.remove(); };
  }, []);

  return online;
}
